var ACC     = ACC || {};
ACC.address = ACC.address || {};

ACC.address.spinner = $("<img src='" + ACC.config.resource.spinner + "' />");
ACC.address.addressID = '';

ACC.address.setupDeliveryAddressPopupForm = function (data) {
    // Fill the available delivery addresses
    $('#summaryDeliveryAddressBook').html($.templates('#deliveryAddressesTemplate').render({addresses: data}));
    // Handle selection of address
    $('#summaryDeliveryAddressBook button.use_address').click(ACC.address.handleSelectExistingAddressClick);
    // Handle edit address
    $('#summaryDeliveryAddressBook button.edit').click(ACC.address.handleEditAddressClick);
    // Handle set default address
    $('#summaryDeliveryAddressBook button.default').click(ACC.address.handleDefaultAddressClick);
};

ACC.address.emptyAddressForm = function () {
    var options = {
        url: getDeliveryAddressFormUrl,
        data: {addressId: ACC.address.addressID, createUpdateStatus: ''},
        type: 'POST',
        success: function (data)
        {
            $('#summaryDeliveryAddressFormContainer').html(data);
        }
    };

    $.ajax(options);
};

ACC.address.handleSelectExistingAddressClick = function () {
    var addressId = $(this).attr('data-address');
    $.postJSON(setDeliveryAddressUrl, {addressId: addressId}, ACC.address.handleSelectExitingAddressSuccess);
    return false;
};

ACC.address.handleEditAddressClick = function () {
    $('#summaryDeliveryAddressFormContainer').show();
    $('#summaryOverlayViewAddressBook').show();
    $('#summaryDeliveryAddressBook').hide();

    var addressId = $(this).attr('data-address');
    var options = {
        url: getDeliveryAddressFormUrl,
        data: {addressId: addressId, createUpdateStatus: ''},
        target: '#summaryDeliveryAddressFormContainer',
        type: 'POST',
        success: function (data)
        {
            $.colorbox.resize();
        },
        error: function (xht, textStatus, ex)
        {
            alert("Failed to update cart. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
        }
    };

    $(this).ajaxSubmit(options);
    return false;
};

ACC.address.handleDropDownAddressClick = function () {

    $(document).on("change", '#addressDropdown', function () {

        ACC.address.setAddressChangedFlag();

        var addressId = $("#addressDropdown option:selected").attr('data-address');
        $(this).closest('.create_update_address_form').find('.help-inline').remove();
        $(this).closest('.create_update_address_form').find('.alert.negative').remove();
        $(this).closest('.create_update_address_form').find('.control-group').removeClass('error');

        if ($.isEmptyObject(addressId)) {

            document.getElementById("address.title_del").options[0].selected = true;
            $("#address\\.firstName_del").val("");
            $("#address\\.surname_del").val("");
            $("#address\\.companyName_del").val("");
            $("#address\\.line2_del").val("");
            $("#address\\.line1_del").val("");
            $("#address\\.additionToAddress_del").val("");
            $("#address\\.shipToName_del").val("");
            $("#address\\.townCity_del").val("");
            $("#address\\.postcode_del").val("");
            $("#addressId").val("");
            $("#address\\.country_del").val("");
        } else {
            $.getJSON($(this).closest('.js-deliveryAddressForm').data("get-selected"), {addressId: addressId}, function (data) {

                // refresh content of inputfields and checkboxes
                if (!data.titleCode) {
                    document.getElementById("address.title_del").options[0].selected = true;
                } else {
                    var options = document.getElementById("address.title_del").options;
                    for (var i = 0; i < options.length; i++) {
                        if (options[i].value === data.titleCode) {
                            options[i].selected = true;
                            break;
                        }
                    }
                }
                $("#address\\.firstName_del").val(ACC.address.getValueOrEmptyString(data.firstName));
                $("#address\\.surname_del").val(ACC.address.getValueOrEmptyString(data.lastName));
                $("#address\\.companyName_del").val(ACC.address.getValueOrEmptyString(data.companyName));
                $("#address\\.line2_del").val(ACC.address.getValueOrEmptyString(data.line2));
                $("#address\\.line1_del").val(ACC.address.getValueOrEmptyString(data.line1));
                $("#address\\.additionToAddress_del").val(ACC.address.getValueOrEmptyString(data.additionToAddress));
                $("#address\\.shipToName_del").val(ACC.address.getValueOrEmptyString(data.shipToName));
                if (!data.country.isocode) {
                    document.getElementById("address.country_del").options[0].selected = true;
                } else {
                    var options = document.getElementById("address.country_del").options;
                    for (var i = 0; i < options.length; i++) {
                        if (options[i].value === data.country.isocode) {
                            options[i].selected = true;
                            break;
                        }
                    }
                }
                $("#address\\.townCity_del").val(ACC.address.getValueOrEmptyString(data.town));
                $("#address\\.postcode_del").val(ACC.address.getValueOrEmptyString(data.postalCode));
                $("#addressId").val(ACC.address.getValueOrEmptyString(data.id));
            });
        }

    });

};

/**
 * @description only kmc - sets an event listener for address selection change
 */
ACC.address.handleDropDownAddressClickKmc = function() {
    $(document).off("change.addressSelection", ".js-addressDropdown");
    $(document).on("change.addressSelection", '.js-addressDropdown', function () {
        var addressId = $(".js-addressDropdown option:selected").attr('data-address');
        var initialAddressId = ACC.address.getInitialAddressId();
        if (addressId != initialAddressId) {
            ACC.address.setAddressChangedFlag();
        }

        var availableBranches = ACC.address.getAvailableBranches();
        // enable all branches
        ACC.address.enableBranches();
        if ($.isEmptyObject(addressId)) {
            $("#address\\.companyName_del").val("");
            $("#address\\.line1_del").val("");
            $("#address\\.line2_del").val("");
            $("#address\\.townCity_del").val("");
            $("#address\\.postcode_del").val("");
            $("#addressId").val("");
            $("#address\\.title_del").val("");
            $("#address\\.firstName_del").val("");
            $("#address\\.surname_del").val("");
            $("#address\\.additionToAddress_del").val("");
            $("#address\\.shipToName_del").val("");
            $("#address\\.country_del").val("");
            $("#address\\.state").val("");
        } else {
            $.getJSON($(this).closest('.js-deliveryAddressForm').data("get-selected"), {addressId: addressId}, function (data) {
                $("#address\\.companyName_del").val(ACC.address.getValueOrEmptyString(data.companyName));
                $("#address\\.line1_del").val(ACC.address.getValueOrEmptyString(data.line1));
                $("#address\\.line2_del").val(ACC.address.getValueOrEmptyString(data.line2));
                $("#address\\.townCity_del").val(ACC.address.getValueOrEmptyString(data.town));
                $("#address\\.postcode_del").val(ACC.address.getValueOrEmptyString(data.postalCode));
                $("#address\\.title_del").val(ACC.address.getValueOrEmptyString(data.titleCode));
                $("#address\\.firstName_del").val(ACC.address.getValueOrEmptyString(data.firstName));
                $("#address\\.surname_del").val(ACC.address.getValueOrEmptyString(data.lastName));
                $("#address\\.additionToAddress_del").val(ACC.address.getValueOrEmptyString(data.additionToAddress));
                $("#address\\.shipToName_del").val(ACC.address.getValueOrEmptyString(data.shipToName));
                $("#address\\.country_del").val(ACC.address.getValueOrEmptyString(data.country.isocode));
                $.isEmptyObject(data.region)
                    ? $("#address\\.state").val('')
                    : $("#address\\.state").val(ACC.address.getValueOrEmptyString(data.region.isocodeShort));
            });
            // disable branches that are not in availableBranches
            ACC.address.disableBranchesExcept(availableBranches);
        }
        ACC.address.handleBranchSelection(availableBranches);
    });
};

ACC.address.getAvailableBranches = function () {
    // Filtering selected afterwards is faster, because the first one is now pure css selector
    return $(".js-addressDropdown option").filter(":selected").attr('data-branch-ids').split(',');
};

/**
 * @description validates the two dropdowns - branch and address
 */
ACC.address.validateBranchSelection = function() {
    var isValid = true;
    var $branchDropdown = $(".js-branchDropdown"),
        $addressDropdown = $('.js-addressDropdown'),
        errorCls = 'error',
        $submitButton = $('.js-button-edit-deliveryaddress-save'),
        branchId = $(".js-branchDropdown option:selected").attr('data-branch'),
        addressIds = $(".js-addressDropdown option:selected").attr('data-address-ids'),
        branchMessageClass = '.branch-select-message',
        addressMessageClass = '.address-select-message',
        formHasChanged = ACC.address.isAddressChanged();

    if (branchId.length <= 0) {
        $branchDropdown.addClass(errorCls);
        $branchDropdown.find(branchMessageClass).show();
        isValid = false;
    } else {
        $branchDropdown.removeClass(errorCls);
        $branchDropdown.find(branchMessageClass).hide();
    }

    if (addressIds.length <= 0) {
        $addressDropdown.addClass(errorCls);
        $addressDropdown.find(addressMessageClass).show();
        isValid = false;
    } else {
        $addressDropdown.removeClass(errorCls);
        $addressDropdown.find(addressMessageClass).hide();
    }

    (!isValid || !formHasChanged) ?
        $submitButton.attr('disabled', true) :
        $submitButton.attr('disabled', false)
};

/**
 * @description enables all branches in Dropdown
 */
ACC.address.enableBranches = function() {
    var disabledText = $('.js-branchDropdownSelect').attr('data-option-disabled-text');
    $(".js-branchDropdown option").removeAttr("disabled");
    $(".js-branchDropdown option").each(function() {
        var oldText = $(this).text();
        $(this).text(
            oldText.replace(disabledText, '')
        );
    })
};

/**
 * @description handles the branch selection
 *
 * @param [String] availableBranches
 */
ACC.address.handleBranchSelection = function(availableBranches) {
    if($('.js-branchDropdown option:selected').is('[disabled]')) {
        $(".js-branchDropdown option").filter(function() {
            return $(this).hasClass('no-branch');
        }).prop('selected', true);
    }
    $('.js-branchDropdown').trigger('change');
};

/**
 * @description disables all branches in Select field, that is not in availableBranches
 * or has class 'no-branch'
 *
 * @param [String] availableBranches
 */
ACC.address.disableBranchesExcept = function(availableBranches) {
    var disabledText = $('.js-branchDropdownSelect').attr('data-option-disabled-text');
    $(".js-branchDropdown option").each(function() {
        var currentBranch = $(this).attr('data-branch');
        if ($(this).hasClass('no-branch')) {
            return;
        }
        if (!availableBranches.includes(currentBranch)) {
            $(this).attr("disabled", true);
            var oldText = $(this).text();
            $(this).text(
                oldText + disabledText
            );
        }
    });
};

/**
 * @description sets an event listener on branch dropdown change event
 */
ACC.address.handleDropDownBranchClickKmc = function() {
    $(document).off("change.addressSelection", ".js-branchDropdown");
    $(document).on("change.addressSelection", ".js-branchDropdown", function(e) {
        var $branchDropdown = $('.js-branchDropdown'),
            $selectedAddress = $('.js-addressDropdown').find('option:selected'),
            branchId = $branchDropdown.find('option:selected').attr('data-branch'),
            availableBranches = $selectedAddress.attr('data-branch-ids').split(','),
            availableAddressIds = $selectedAddress.attr('data-address-ids').split(',');

        // sets branch id on hidden input field
        $branchDropdown.find('.js-branchIdHiddenInput').val(branchId);
        // shows message if branch id is empty

        ACC.address.setAddressIdByBranches(branchId, availableBranches, availableAddressIds);
        ACC.address.validateBranchSelection();
    });
};

/**
 * @description set address id according to corresponding branch
 *
 * @param String branchId
 * @param [String] availableBranches
 * @param [String] availableAddressIds
 */
ACC.address.setAddressIdByBranches = function(branchId, availableBranches, availableAddressIds) {
    var newAddressId = "",
        initialAddressId = ACC.address.getInitialAddressId();

    if (branchId.length > 0 && availableAddressIds.length == availableBranches.length) {
        newAddressId = availableAddressIds[availableBranches.indexOf(branchId)]
    }
    $(".js-addressId").val(ACC.address.getValueOrEmptyString(newAddressId));

    if (initialAddressId !== newAddressId) {
        ACC.address.setAddressChangedFlag();
    }
};

ACC.address.getInitialAddressId = function() {
    return $('.js-initial-address-id').val();
};

/**
 * This is called form html of the dialog that is retrieved via ajax. This means its executed while the html is added
 * to the dom.
 */
ACC.address.initFormHandlerKmc = function() {
    ACC.address.initFormHandler();
    // this method can be called multiple times in one page, so remove the existing event handlers first
    $('.js-branchDropdownSelect').off('change', ACC.address.setAddressChangedFlag);
    $('.js-branchDropdownSelect').on('change', ACC.address.setAddressChangedFlag);

    ACC.address.disableBranchesExcept(ACC.address.getAvailableBranches());
};

/**
 * Looks for user input or dropdown click in the delivery address form and sets the value of #isAddressChanged to true
 * But only if cart has entries.
 */
ACC.address.initFormHandler = function(){
    $("#deliveryAddressForm [id^=address\\.]").on("input", ACC.address.setAddressChangedFlag);
    $('.js-b2bUnitDropdownSelect').off('change', ACC.address.b2bUnitDropdownSelect);
    $('.js-b2bUnitDropdownSelect').on('change', ACC.address.b2bUnitDropdownSelect);
    $('.js-cancelCompanySelection').off('click', ACC.address.cancelCompanySelection);
    $('.js-cancelCompanySelection').on('click', ACC.address.cancelCompanySelection);
};

ACC.address.setAddressChangedFlag = function(){
    $('input[name=isAddressChanged]').val(true);

    // Hide unbuyable products if the js-unbuyable-products-container is visible AND master cart type is not contract
    if( $('.js-unbuyable-products-container').is(":visible") && $('input[name=masterCartType]').val() != 'CONTRACT' ){

        if( $('.js-unbuyable-products-container') ) {
            $('.js-unbuyable-products-container').addClass('hidden');
            $(this).colorbox.resize();
        }
    }
};

ACC.address.isAddressChanged = function(){
    return $('input[name=isAddressChanged]').val();
};

ACC.address.getValueOrEmptyString = function (value) {
    if(!value){
        return '';
    } else {
        return value;
    }
};

ACC.address.handleDefaultAddressClick = function () {
    var addressId = $(this).attr('data-address');
    var options = {
        url: setDefaultAddressUrl,
        data: {addressId: addressId},
        type: 'POST',
        success: function (data)
        {
            ACC.address.setupDeliveryAddressPopupForm(data);
        },
        error: function (xht, textStatus, ex)
        {
            alert("Failed to update address book. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
        }
    };

    $(this).ajaxSubmit(options);
    return false;
};

ACC.address.handleSelectExitingAddressSuccess = function (data) {
    if (data != null)
    {
        ACC.refresh.refreshPage(data);
        parent.$.colorbox.close();
    }
    else
    {
        alert("Failed to set delivery address");
    }
};

ACC.address.bindSuggestedDeliveryAddresses = function () {
    var status = $('.add_edit_delivery_address_id').attr('status');
    if (status != null && "hasSuggestedAddresses" == status)
    {
        ACC.address.showSuggestedAddressesPopup();
    }
};

ACC.address.showSuggestedAddressesPopup = function () {
    $.colorbox({
        inline: true,
        height: false,
        innerWidth: 525,
        href: "#popup_suggested_delivery_addresses",
        overlayClose: false,
        onComplete: function ()
        {
            $(this).colorbox.resize();
        }
    });
};

ACC.address.bindCountrySpecificAddressForms = function () {
    $('#countrySelector :input').on("change", function ()
    {
        var options = {
            'addressCode': '',
            'countryIsoCode': $(this).val()
        };
        ACC.address.displayCountrySpecificAddressForm(options, ACC.address.showAddressFormButtonPanel);
    })

};

ACC.address.showAddressFormButtonPanel = function () {
    if ($('#countrySelector :input').val() !== '')
    {
        $('#addressform_button_panel').show();
    }
};

ACC.address.showAddressBook = function () {
    $(document).on("click", "#viewAddressBook", function ()
    {
        var data = $("#savedAddressListHolder").html();
        $.colorbox({
            height: false,
            html: data,
            onComplete: function ()
            {
                $(this).colorbox.resize();
            }
        });

    })
};

ACC.address.showRemoveAddressConfirmation = function () {
    $(document).on("click", ".removeAddressButton", function (e)
    {
        e.preventDefault();
        var addressId = $(this).data("addressId");
        $.colorbox({
            innerWidth: '500px',
            inline: true,
            height: false,
            href: "#popup_confirm_address_removal_" + addressId,
            onComplete: function ()
            {
                $(this).colorbox.resize();
            }
        });
    })
};

ACC.address.bindToColorboxClose = function () {
    $(document).on("click", ".cancel_button", function (e)
    {
        e.preventDefault();
        $.colorbox.close();
    })
};

ACC.address.displayCountrySpecificAddressForm = function (options, callback) {
    $.ajax({
        url: ACC.address.myAccountAddressFormUrl,
        async: true,
        data: options,
        dataType: "html",
        beforeSend: function ()
        {
            $("#i18nAddressForm").html(ACC.address.spinner);
        }
    }).done(function (data)
            {
                $("#i18nAddressForm").html($(data).html());
                if (typeof callback == 'function')
                {
                    callback.call();
                }
            });
};

ACC.address.bindViewAddressBook = function () {
    $(document).on("click", '#summaryOverlayViewAddressBook', function ()
    {
        $('#summaryDeliveryAddressFormContainer').hide();
        $('#summaryOverlayViewAddressBook').hide();
        $('#summaryDeliveryAddressBook').show();
        $.colorbox.resize();
    });
};

ACC.address.showAddressPupUp = function () {
    $(".add-address, .button.edit-address").on("click", function (e)
    {
        e.preventDefault();
        var url = $(this).attr('href');
        $.ajax({
            url: url,
            success: function (data) {
                $.colorbox({
                    width: false,
                    innerWidth: "860px",
                    html: $(data).find('#addressForm'),
                    scrolling: false,
                    onLoad: function() {
                        $('#cboxClose').remove();
                    },
                    onComplete: function (){
                        $(this).colorbox.resize();
                    }
                });
                ACC.address.validateAddressPopUp();
            }
        });
    })
};

ACC.address.validateAddressPopUp = function() {
    $('#colorbox #addressForm').find('.cancel-button').on("click", function (e) {
        e.preventDefault();
        $.colorbox.close();
    });
    $('#colorbox #addressForm').ajaxForm({
       success: function(data){
           if($(data).find('#addressForm').length){ // show errors in address form
               $('#cboxLoadedContent').html($(data).find('#addressForm'));
               $('#addressForm').prepend($(data).find('#globalMessages'));
               ACC.address.validateAddressPopUp();
               ACC.address.handleInputError();
               $.colorbox.resize();
           }else{ // show messages and content after update
               $('#globalMessages').html($(data).find("#globalMessages").html());
               $('.address-book-content-wrapper').html($(data).find(".address-book-content-wrapper").html());
               $.colorbox.close();
               $(window).scrollTop(0);
               ACC.address.bindAll();
           }
       }
    });
};

ACC.address.handleInputError = function() {
    $('.myaccount-addressForm').find('.second-row').each(function(){
        var error = $(this).find('.help-inline').detach();
        error.appendTo($(this).prev('.first-row'));
    });
};

ACC.address.openAddressPopup = function() {
    var openColorBox = function () {
        $.colorbox({
            inline: true,
            href: "#summaryDeliveryAddressOverlay",
            innerWidth: "890px",
            escKey: false,
            overlayClose: true,
            onLoad: function () {
                $('#cboxClose').remove();
            },
            onComplete: function () {
                ACC.common.refreshScreenReaderBuffer();
                ACC.checkoutB2B.validateDeliveryAddressPopUp();
                $.colorbox.resize();
            },
            onClosed: function () {
                ACC.common.refreshScreenReaderBuffer();
            }
        });
    };

    $("#summaryDeliveryAddressBook").hide();

    var changeFormUrl = $(".js-summaryDeliveryAddress").data('change-form');
    var getUrl = $(".js-summaryDeliveryAddress").data('get');

    ACC.checkoutB2B.showAddressForm(changeFormUrl, getUrl, openColorBox, false);
};

ACC.address.b2bUnitDropdownSelect = function() {
    ACC.address.validateB2BUnitDropdownSelection(this);
};

ACC.address.validateB2BUnitDropdownSelection = function(selectElement) {
    selectElement = $(selectElement);
    var currentparentunituid = selectElement.data('currentparentunituid');
    if (currentparentunituid == selectElement[0].value) {
        $('#confirmCompanyActions').hide();
    } else {
        $('#confirmCompanyActions').show();
    }
};

ACC.address.cancelCompanySelection = function(e) {
    e.preventDefault();

    var b2bUnitDropdownSelect = $('#b2bUnitDropdownSelect');
    b2bUnitDropdownSelect.val(b2bUnitDropdownSelect.data('currentparentunituid'));

    ACC.address.validateB2BUnitDropdownSelection(b2bUnitDropdownSelect);
};

ACC.address.bindAll = function () {
    this.showRemoveAddressConfirmation();
    this.showAddressPupUp();
    this.bindToColorboxClose();
};

ACC.address.handleDropDownBillingAddressClick = function () {

    // attach an event to billing addresses drop down
    $(document).on("change", '#billingAddressDropdown', function () {

        // set the selected address PK to the form hidden input
        $('input[name=addressPk]').val($('.select-editBillingAddress-chooseAddress option:selected').attr("data-address"));

        // set the form hidden value for check the address is changed
        $('input[name=isAddressChanged]').val(true);

        // hide error div
        $(this).closest('.update_address_form').find('.help-inline').remove();
        $(this).closest('.update_address_form').find('.alert.negative').remove();
        $(this).closest('.update_address_form').find('.control-group').removeClass('error');
    });
};

ACC.address.handleCloseBillingAddressButton = function () {
    // attach the close event to cancel link
    $('.js-button-edit-billingAddress-cancel').on("click", function (e) {
        e.preventDefault();
        $('.js-button-edit-billingAddress-cancel').attr('data-isclicked', 'true');
        $.colorbox.close();
    });
};

/* Extend jquery with a postJSON method */
jQuery.extend({
    postJSON: function (url, data, callback) {
        return jQuery.post(url, data, callback, "json");
    }
});

// Address Verification
$(document).ready(function () {
    ACC.address.bindAll();
});
